const COLORS = [
  "bg-red-500",
  "bg-orange-500",
  "bg-amber-500",
  "bg-yellow-500",
  "bg-lime-500",
  "bg-green-500",
  "bg-emerald-500",
  "bg-teal-500",
  "bg-cyan-500",
  "bg-sky-500",
  "bg-blue-500",
  "bg-indigo-500",
  "bg-violet-500",
  "bg-purple-500",
  "bg-fuchsia-500",
  "bg-pink-500",
  "bg-rose-500",
];

const HOVER_COLORS = [
  "hover:bg-red-700",
  "hover:bg-orange-700",
  "hover:bg-amber-700",
  "hover:bg-yellow-700",
  "hover:bg-lime-700",
  "hover:bg-green-700",
  "hover:bg-emerald-700",
  "hover:bg-teal-700",
  "hover:bg-cyan-700",
  "hover:bg-sky-700",
  "hover:bg-blue-700",
  "hover:bg-indigo-700",
  "hover:bg-violet-700",
  "hover:bg-purple-700",
  "hover:bg-fuchsia-700",
  "hover:bg-pink-700",
  "hover:bg-rose-700",
];

const TEXT_COLORS = [
  "text-red-500",
  "text-orange-500",
  "text-amber-500",
  "text-yellow-500",
  "text-lime-500",
  "text-green-500",
  "text-emerald-500",
  "text-teal-500",
  "text-cyan-500",
  "text-sky-500",
  "text-blue-500",
  "text-indigo-500",
  "text-violet-500",
  "text-purple-500",
  "text-fuchsia-500",
  "text-pink-500",
  "text-rose-500",
];

const SHADOW_COLORS = [
  "shadow-red-900",
  "shadow-orange-900",
  "shadow-amber-900",
  "shadow-yellow-900",
  "shadow-lime-900",
  "shadow-green-900",
  "shadow-emerald-900",
  "shadow-teal-900",
  "shadow-cyan-900",
  "shadow-sky-900",
  "shadow-blue-900",
  "shadow-indigo-900",
  "shadow-violet-900",
  "shadow-purple-900",
  "shadow-fuchsia-900",
  "shadow-pink-900",
  "shadow-rose-900",
];

export { COLORS, HOVER_COLORS, TEXT_COLORS, SHADOW_COLORS };
